import { ActionMap } from "@context/types/index";

export enum TypesLoading {
  Loading = "LOADING",
  NotLoading = "NOTLOADING",
}

export type LoadingPayload = {
  [TypesLoading.Loading]: undefined;
  [TypesLoading.NotLoading]: undefined;
};

export type LoadingActions = ActionMap<LoadingPayload>[keyof ActionMap<LoadingPayload>];
